
import "ie-array-find-polyfill";
require('intersection-observer');

import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import './permission'


import '@/style/base.css'
import '@/style/global.scss'


import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)

Vue.prototype.$wechat = wx
Vue.wechat = wx
wx.miniProgram.getEnv((res) => {
console.log('miniProgram.getEnv',res)
let is = false
if (res && res.miniprogram) {
console.log('在小程序内', store)
is = true
} else {
console.log('不在小程序内', store)
}
store.dispatch('setIsMiniprogram', is)
})


import ShareUtil from '@/plugins/ShareUtil'
Vue.use(ShareUtil)
import BaiduAnalysis from '@/plugins/BaiduAnalysis'
Vue.use(BaiduAnalysis)
import EventAnalysis from '@/plugins/EventAnalysis'
Vue.use(EventAnalysis)
import ADManager from '@/plugins/ADManager'
Vue.use(ADManager)
import KBManager from '@/plugins/KBManager'
Vue.use(KBManager)
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
const infiniteScroll = require('@/directives/vue-infinite-scroll')
Vue.use(infiniteScroll.infiniteScroll)
import EmojiUtil from '@/utils/emoji'
Vue.filter('emojize', function (content, scale) {
if (!content) return ''
scale = scale || 1
content = content.toString()
content = EmojiUtil.replaceEmojiText(content, scale)

return content
})
Vue.config.ignoredElements = [ // 忽略自定义元素标签抛出的报错
'wx-open-launch-weapp',
];
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false

const eventHub = new Vue()
window.eventHub = eventHub

var myApp = new Vue({
router,
store,
render: h => h(App)
}).$mount('#app')
window.myApp = myApp



// WEBPACK FOOTER //
// ./src/main.js